/*!

Stripe keys:
pk_live_cRuSHYW8xJI4ygY1pVFX4ibA
pk_test_4tndhveR7LPa5ubTulbnxrbo

*/
import React from "react";
import ReactDOM from "react-dom";
import { HashRouter, BrowserRouter, Route, Switch, Redirect } from "react-router-dom";

import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/css/animate.min.css";
import "./assets/css/roboto.css";
import "./assets/sass/light-bootstrap-dashboard-react.scss?v=1.3.0";
import "./assets/css/demo.css";
import "./assets/css/pe-icon-7-stroke.css";

import AdminLayout from "layouts/Home.jsx";
import {StripeProvider} from 'react-stripe-elements';

var PADDLE_CONFIG = {};

var Paddle = window.Paddle || {};

try{
    if(process.env.NODE_ENV === 'production' && window.location.href.indexOf('staging.flowpaper.com')==-1){
      PADDLE_CONFIG = {
        type : 'production',
        clientToken: "live_d297c02ab3cf05b3128bfcad082",
        prices: {
          Zine: {
            domain1: 'pri_01jmk5rt07fkwq9tygtadgfbrr',  
            domain2: 'pri_01jmk5snwgkzw7qy4vvhgy06gs',  
            domain3: 'pri_01jmk5v0xhxyj755t1t9g1pqz3',
            unlimited: 'pri_01jmk5wa3t3dnbasa10cnw42dj', 
          },
          Creative: {
            '6monthly': "pri_01jmk5z8scmfggdye9bwd7n37n", 
            'annually': "pri_01jmk60gtyc700mpvez6b34n01" 
          },
          Team: {
            '6monthly': "pri_01jmk639v6637x0qzrhcb1pcgf", 
            'annually': "pri_01jmk66a5bhcn04sf0sm2fc0qk"  
          },    
          Pro: {
            'annually': "pri_01jmk6gtm90zbhrnw6mm861v1n" 
          },
          ExtraStorage:{
            Extra50 : 'pri_01jp2xy7htmcv21ngfwnwp019f',
            Extra500 : 'pri_01jqsxmbs6kd28xssxkwhdtzsf',
          },
          Services:'pri_01jp0k7akn9y7exndfzcc442hy',
          AdditionalDomain:'pri_01jp37dn4jcyr5c503vn0n936x',
          UpdatePaymentDetails:'pri_01jqa620vqpne6y6m4n344bw53'
        }
      }

      Paddle.Environment.set("production");
    }else{
      PADDLE_CONFIG = {
        type: 'sandbox',
        clientToken: "test_2ca23d88b6126ad87d40d4c7807",
        prices: {
          Zine: {
            domain1: 'pri_01jmqs1k3vg7g22rvne7jsys3x', 
            domain2: 'pri_01jmqywag42478gqge9114rm1y', 
            domain3: '', 
            unlimited: '',
          },
          Creative: {
            '6monthly': "pri_01jnc9gd0djypwf8ghyk9nv4ts", 
            'annually': "pri_01jn2e1ca61eyv4rc2fp2x3zkg" 
          },
          Team: {
            '6monthly': "pri_01jnc9j2q1j6rv5t9ny1mmwbj0",
            'annually': "pri_01jnc9jma67be8t9wtjge79bt1"
          },    
          Pro: {
            'annually': "xx"
          },
          ExtraStorage:{
            Extra50 : 'xx',
            Extra500 : 'xx',
          },
          Services:'pri_01jp3171g6k4hq08k311cw76dk',
          AdditionalDomain:'pri_01jp37c9s63qafxqs1y155fv0r',
          UpdatePaymentDetails:'pri_01jqa5zw6srykec08q82b7hr2h'
        }
      }

      Paddle.Environment.set("sandbox");
    }

    Paddle.Initialize({
      token: PADDLE_CONFIG.clientToken,
      eventCallback: function (event) {
          console.log("Paddle event:", event);
          
          if(event && event.name == 'checkout.loaded'){
            // document.querySelector('.paddlePaymentFormPlaceholder').style.display = 'none';
            // document.querySelector('.paddle-target-container').style.display = 'block';
          }
      }
      
    });
    
    window.PADDLE_CONFIG = PADDLE_CONFIG;
}catch(e){
  console.log('Error initializing paddle',e);
}

const stripe_key = process.env.NODE_ENV === 'production' && window.location.href.indexOf('staging.flowpaper.com')==-1 && window.location.href.indexOf('localhost')==-1
  ? "pk_live_cRuSHYW8xJI4ygY1pVFX4ibA"
  : "pk_test_4tndhveR7LPa5ubTulbnxrbo";

ReactDOM.render(
  <StripeProvider apiKey={stripe_key}>
  <HashRouter>
    <Switch>
      <Route path="/home" render={props => <AdminLayout {...props} />}/>
      <Redirect from="/" to="/home/user" />
    </Switch>
  </HashRouter>
  </StripeProvider>,
  document.getElementById("root")
);
